// 服務英文名稱（software_services.name）→ 中文顯示名稱對照表
//
// 對照來源：行銷頁服務卡片 + DB client_api.software_services
// 使用時機：後端 /api/software-services 的服務名顯示一律走這張對照表（getServiceName）。
//           先取得後端英文 name，再轉成對照中文；查無對照才原樣顯示英文（平台層產品）。
//           注意：不要優先採用後端的 name_local，實測後端回傳的是英文，會蓋掉對照表、
//           導致畫面（例如「管理方案」彈窗）出現英文服務名。對照表才是顯示中文的權威來源。
//
// 備註：
// - Keystone Core 顯示為「任務管理」（與行銷頁一致）；Keystone Core Performance 為「績效管理」。
// - eip Management 對應「簽核管理」（EIP 企業資訊入口的簽核模組）。
// - 平台層產品（Content Gallery Platform、Marketing Builder Platform、Customer Data Platform、
//   Financial Statement Platform、Sales Growth Platform、START-ONE）「確認維持英文品牌名」，
//   刻意不列入 → getServiceName 會原樣回傳英文。這是刻意決定，不是漏翻，請勿當 TODO 補上。
export const SERVICE_NAME_MAP = {
  // 核心服務
  "AI Analysis": "AI 分析",
  Agent: "代理人",
  "File Center": "檔案中心",
  "Keystone Core": "任務管理",
  "Document Management": "文件管理",
  "Strategy Mindmap": "心智圖",
  // 企業限定服務
  "Org Chart": "組織管理",
  "Permission Management": "權限管理",
  "eip Management": "簽核管理",
  "Keystone Core Performance": "績效管理",
  "Data Center": "資料中心",
  "Automation Task": "自動化任務",
  "Approval Management": "簽核管理",
  Blueprint: "經營藍圖",
};

// 傳入英文服務名稱，回傳對應中文；查無對照時原樣回傳（含空值防呆）
export const getServiceName = (name) =>
  name == null ? "" : SERVICE_NAME_MAP[name] ?? name;
